function findSwymWishlistIcon(container) {
  return (
    container.querySelector('#swym-advanced-header-icon-mobile') ||
    container.querySelector('#swym-advanced-header-icon') ||
    container.querySelector('.swym-header-icon-wrapper') ||
    container.querySelector('a[href*="wishlist"]:not(#header-wishlist-icon)')
  );
}

function ensureWishlistLabel(link, placeholder) {
  if (link.querySelector('.icon__label')) return;

  const label = document.createElement('div');
  label.className = 'icon__label';
  label.textContent = placeholder.dataset.label || 'Wishlist';
  link.appendChild(label);
}

function ensureWishlistIconStructure(link) {
  const icon = link.querySelector('svg');
  if (icon && !icon.closest('span')) {
    const span = document.createElement('span');
    icon.parentNode.insertBefore(span, icon);
    span.appendChild(icon);
  }
}

function enhanceHeaderWishlistIcon() {
  const iconsContainer = document.querySelector('.header__icons');
  const placeholder = document.getElementById('header-wishlist-icon');
  if (!iconsContainer || !placeholder) return false;

  const swymRoot = findSwymWishlistIcon(iconsContainer);
  if (!swymRoot || swymRoot === placeholder) return false;

  const link = swymRoot.tagName === 'A' ? swymRoot : swymRoot.closest('a') || swymRoot;
  link.classList.add('header__icon', 'header__icon--wishlist', 'link', 'focus-inset');

  ensureWishlistIconStructure(link);
  ensureWishlistLabel(link, placeholder);

  const appBlock = link.closest('.shopify-app-block');
  if (appBlock) {
    appBlock.classList.add('header-wishlist-app-block');
  }

  placeholder.hidden = true;
  return true;
}

function initHeaderWishlistIcon() {
  const iconsContainer = document.querySelector('.header__icons');
  if (!iconsContainer) return;

  const run = () => enhanceHeaderWishlistIcon();

  if (run()) return;

  const observer = new MutationObserver(() => {
    if (run()) observer.disconnect();
  });

  observer.observe(iconsContainer, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderWishlistIcon);
} else {
  initHeaderWishlistIcon();
}
